/**
 * Utility functions for device detection
 */

/**
 * Checks if the current device is a mobile device
 * @returns {boolean} True if the device is mobile, false otherwise
 */
export const isMobileDevice = () => {
  // Check if window is defined (for SSR)
  if (typeof window === 'undefined') return false;
  
  // Check using user agent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Regular expression for mobile devices
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  
  // Check using screen width (typically mobile devices are less than 768px wide)
  const isMobileWidth = window.innerWidth < 768;
  
  return mobileRegex.test(userAgent) || isMobileWidth;
};
